import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { ImageUrl } from '../../../../../Helpers/request'
import { LazyLoadImage } from "react-lazy-load-image-component";

import BraceletImg from '../../../../../Assets/img/brac.png'
import EarringsImg from '../../../../../Assets/img/ear.png'
import PendantImg from '../../../../../Assets/img/pend.png'

let categoryData = [
  {
    img: BraceletImg,
    title: "Bracelets",
    link: "/jewelry/bracelets"
  },
  {
    img: EarringsImg,
    title: "Earrings",
    link: "/jewelry/earrings"
  },
  {
    img: PendantImg,
    title: "Pendants",
    link: "/jewelry/pendants"
  }
]
const MacauCategory = () => {
  return (
    <div className='pt80 ptMob30'>
      <Container className='containerV1'>
        <Row className='gy-4'>
          {categoryData.map((e, i) => (
            <Col className="mb-3" lg={4} md={4} key={i}>
              <div className="box_img position-relative overflow-hidden">
                <div className="picture overflow-hidden">
                  <Link to={e.link}>
                    <LazyLoadImage
                      src={e?.img}
                      className="img-fluid transition"
                      alt={e.title}
                    />
                  </Link>
                </div>
                <div className="info">
                  <h3 className="title fontMessiri">{e.title}</h3>
                  <div className="buttonLink">
                    <a href={e.link} className="button-banner text-dark">
                      Shop now
                    </a>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>

    </div>
  )
}

export default MacauCategory
